var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.707 20.293L18.025 16.611C19.4651 14.8095 20.1607 12.5249 19.9688 10.2265C19.777 7.92817 18.7123 5.79051 16.9935 4.25267C15.2746 2.71483 13.0321 1.89357 10.7267 1.95758C8.42118 2.0216 6.22773 2.96603 4.59688 4.59688C2.96603 6.22773 2.0216 8.42118 1.95758 10.7267C1.89357 13.0321 2.71483 15.2746 4.25267 16.9935C5.79051 18.7123 7.92817 19.777 10.2265 19.9688C12.5249 20.1607 14.8095 19.4651 16.611 18.025L20.293 21.707L21.707 20.293ZM11 18C9.61557 18 8.26219 17.5895 7.11104 16.8203C5.9599 16.0512 5.06269 14.9579 4.53288 13.6788C4.00307 12.3997 3.86444 10.9923 4.13454 9.6344C4.40464 8.27654 5.07132 7.02926 6.05029 6.05029C7.02926 5.07132 8.27654 4.40464 9.6344 4.13454C10.9923 3.86444 12.3997 4.00307 13.6788 4.53288C14.9579 5.06269 16.0512 5.9599 16.8203 7.11104C17.5895 8.26219 18 9.61557 18 11C17.9979 12.8559 17.2597 14.6351 15.9474 15.9474C14.6351 17.2597 12.8559 17.9979 11 18Z",
    fill: "#9A9AB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/search.icon.8f679c57fc8ce6d8d868b2f968ebcc7c.svg";
export { ForwardRef as ReactComponent };